import { faCircleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";

export function OrdersTopSection() {
  return (
    <div className="row row-bordered">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h4>Orders</h4>
        <div style={{ display: "flex", justifyContent: "end" }} className="pl-5">
          <Form>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridEmail">
                <Form.Control type="email" placeholder="Street" />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridEmail">
                <Form.Control type="email" placeholder="City" />
              </Form.Group>
              <Col sm={2}>
                <Button variant="outline-dark" className="px-5">
                  Search
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default function Orders() {
  return (
    <Container>
      <OrdersTopSection />
      <Table striped bordered hover className="pt-5">
        <thead>
          <tr>
            <th>Report Address</th>
            <th>Report Type</th>
            <th>Date Ordered</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1327 Gulfway Dr Port Arthur Texas</td>
            <td>Brick of 10 (STANDARD)</td>
            <td>10/24/2022</td>
            <td>refunded</td>
            <td>
              <FontAwesomeIcon icon={faCircleDown} />
            </td>
          </tr>
          <tr>
            <td>Gulfway Dr Port Arthur Texas</td>
            <td>Brick of 10 (EXTENDED)</td>
            <td>12/24/2022</td>
            <td>delivered</td>
            <td>
              <FontAwesomeIcon icon={faCircleDown} />
            </td>
          </tr>
        </tbody>
      </Table>
    </Container>
  );
}
